import { h, Component, Fragment } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import Admin from "../../../../services/admin";
import User from "../../../../services/user";
import Session from "../../utils/session";
import { FiltersRow, InputFilter, InputRow, SelectRow } from "../../utils/table-utils";
import MoneyFormatter from "../../utils/money-formatter";
import { DateHelperFilter, PerPageFilter, TableFormatter } from "../../utils/form-utils";
import PopupLayout from "../site/popup-layout";

import * as U from "../../desktop-templates/menu-user";
import * as I from "../../utils/icons";

import AwrabetDashboardPage, {
    NewUserForm as AwrabetNewUserForm,
    UserTransfers as AwrabetUserTransfers,
    UserList as AwrabetUserList,
    UserTransactions as AwrabetUserTransactions,
} from "../../../awrabet/desktop-components/user/menu-dashboard";

export default class DashboardPage extends AwrabetDashboardPage {
    render() {
        return <div>
            <U.SubTabsContainer>
                {Object.entries(this.state.tabs.list).map(
                    ([key, item]) => <U.Tab selected={key === this.state.tabs.current} onClick={e => this.switchTabs(key)}>{item.label}</U.Tab>
                )}
            </U.SubTabsContainer>
            <div class="user-menu-headermain-text-color p-2 text-base font-bold m-3 capitalize rounded">{this.state.tabs.list[this.state.tabs.current].description}</div>
            {this.state.tabs.current === 'newuser' && <NewUserForm />}
            {this.state.tabs.current === 'transfers' && <UserTransfers />}
            {this.state.tabs.current === 'userlist' && <UserList openTransactionsClick={username => {
                this.state.tabs.username = username;
                this.state.tabs.current = 'transactions';
                this.setState(this.state);
            }} />}
            {this.state.tabs.current === 'transactions' && <UserTransactions username={this.state.tabs.username} />}
        </div>;
    }
}

class NewUserForm extends AwrabetNewUserForm {
    renderFormSteps() {
        const maxIndex = this.state.steps.available.length - 1;
        const isCompleted = step => this.state.steps.completed.indexOf(step) !== -1;
        return <div class="w-full flex items-center justify-center">
            {this.state.steps.available.map(
                (step, i) => <FormStepLabel selected={this.state.steps.current == i} completed={isCompleted(i)} id={i + 1} name={step} />
            )}
        </div>;
    }

    render() {
        return <div class="px-3">
            {!!this.state.done && <div>
                <FiltersRow>
                    <div class="py-1 px-2 w-1/2">
                        <div>
                            <div><span><Trans>User ID</Trans></span></div>
                            <div class="px-2 py-1 rounded border bg-white flex-1 w-full text-link-500">
                                {this.state.done.idstruttura}
                            </div>
                        </div>
                    </div>
                    <div class="py-1 px-2 w-1/2">
                        <div>
                            <div><span><Trans>Username</Trans></span></div>
                            <div class="px-2 py-1 rounded border bg-white flex-1 w-full text-link-500">
                                {this.state.done.username}
                            </div>
                        </div>
                    </div>
                </FiltersRow>
                <FiltersRow>
                    <div class="py-1 px-2 w-1/2">
                        <div>
                            <div><span><Trans>Email</Trans></span></div>
                            <div class="px-2 py-1 rounded border bg-white flex-1 w-full text-link-500">
                                {this.state.input.email}
                            </div>
                        </div>
                    </div>
                    <div class="py-1 px-2 w-1/2">
                        <div>
                            <div><span><Trans>Password</Trans></span></div>
                            <div class="px-2 py-1 rounded border bg-white flex-1 w-full text-link-500">
                                {this.state.input.password}
                            </div>
                        </div>
                    </div>
                </FiltersRow>
                <FiltersRow>
                    <div class="py-1 px-2 w-1/2">
                        <div>
                            <div><span><Trans>Valuta</Trans></span></div>
                            <div class="px-2 py-1 rounded border bg-white flex-1 w-full text-link-500">
                                {this.state.done.preferred_currency}
                            </div>
                        </div>
                    </div>
                    <div class="py-1 px-2 w-1/2">
                        <div>
                            <div><span><Trans>Disponibilità</Trans></span></div>
                            <div class="px-2 py-1 rounded border bg-white flex-1 w-full text-link-500">
                                <MoneyFormatter value={this.state.done.amount} currency={this.state.done.preferred_currency} />
                            </div>
                        </div>
                    </div>
                </FiltersRow>
                <p class="p-3 font-bold text-center main-color">
                    <Trans>Utente creato con successo!</Trans>
                </p>
                {this.state.transfer !== false && <p class="p-3 font-bold text-center warning-color">
                    <Trans>Non è stato possibile effettuare il deposito iniziale a causa di un errore tecnico: {this.state.transfer}</Trans>
                </p>}
                <FiltersRow class="pt-5 px-5 items-center justify-center">
                    <input
                        type="button"
                        class="px-4 py-2 sm:ml-5 bg-amber-400 text-black rounded m-auto"
                        value={window.Translation(msg`Continua`)}
                        onClick={e => this.resetForm()}
                    />
                </FiltersRow>
            </div>}

            {!this.state.done && <Fragment>
                <div class="text-xs mb-3">
                    {this.renderFormSteps()}
                </div>

                <div class="px-4">
                    <form id="step-form" method="post" onSubmit={e => { e.preventDefault(); !!e.target.checkValidity() && this.switchStep(this.state.steps.current + 1); }}>
                        {/* Form - Step 1 */}
                        {this.state.steps.current === 0 && <Fragment>
                            <FiltersRow>
                                <InputRow
                                    label={<span>{window.Translation(msg`Phone Number`)}<span class="warning-color">*</span></span>}
                                    type="text"
                                    onInput={e => {
                                        this.state.input.username = e.target.value;
                                        this.setState({});
                                    }}
                                    value={this.state.input.username}
                                    required={true}
                                />
                                <InputRow
                                    label={<span>{window.Translation(msg`Email`)}</span>}
                                    type="email"
                                    onInput={e => {
                                        this.state.input.email = e.target.value;
                                        this.setState({});
                                    }}
                                    value={this.state.input.email}
                                />
                            </FiltersRow>
                            <FiltersRow>
                                <InputRow
                                    id="password"
                                    label={<span>{window.Translation(msg`Password`)}<span class="warning-color">*</span></span>}
                                    type="password"
                                    onInput={e => {
                                        e.target.setCustomValidity('');
                                        this.state.input.password = e.target.value;

                                        if (this.state.input.password.length < 6) {
                                            e.target.setCustomValidity(window.Translation(msg`La password deve avere 6 o più caratteri`));
                                        }

                                        this.setState({});
                                    }}
                                    value={this.state.input.password}
                                    required={true}
                                />
                                <InputRow
                                    id="confpass"
                                    label={<span>{window.Translation(msg`Conferma Password`)}<span class="warning-color">*</span></span>}
                                    type="password"
                                    onInput={e => {
                                        e.target.setCustomValidity('');
                                        this.state.input.confpass = e.target.value;

                                        if (this.state.input.confpass !== this.state.input.password) {
                                            e.target.setCustomValidity(window.Translation(msg`Le due password devono coincidere`));
                                        }

                                        this.setState({});
                                    }}
                                    value={this.state.input.confpass}
                                    required={true}
                                />
                            </FiltersRow>
                            <FiltersRow>
                                <InputRow
                                    label={<span>{window.Translation(msg`Nome`)}</span>}
                                    type="text"
                                    onInput={e => {
                                        this.state.input.firstname = e.target.value;
                                        this.setState({});
                                    }}
                                    value={this.state.input.firstname}
                                />
                                <InputRow
                                    label={<span>{window.Translation(msg`Cognome`)}</span>}
                                    type="text"
                                    onInput={e => {
                                        this.state.input.lastname = e.target.value;
                                        this.setState({});
                                    }}
                                    value={this.state.input.lastname}
                                />
                            </FiltersRow>
                        </Fragment>}

                        {/* Form - Step 2 */}
                        {this.state.steps.current === 1 && <Fragment>
                            <FiltersRow>
                                <SelectRow
                                    label={<span>{window.Translation(msg`Paese Di Residenza`)}</span>}
                                    onChange={e => {
                                        this.state.input.residence_country = e.currentTarget.value;
                                        this.setState({});
                                    }}
                                >
                                    <option value=""><Trans>Scegli un paese...</Trans></option>
                                    {this.state.countries.map(
                                        country => <option value={country.code} selected={country.code === this.state.input.residence_country}>{country.name}</option>
                                    )}
                                </SelectRow>
                                <InputRow
                                    label={<span>{window.Translation(msg`Stato/Provincia/Regione`)}</span>}
                                    type="text"
                                    onInput={e => {
                                        this.state.input.residence_state = e.target.value;
                                        this.setState({});
                                    }}
                                    value={this.state.input.residence_state}
                                />
                            </FiltersRow>
                            <FiltersRow>
                                <FiltersRow>
                                    <InputRow
                                        label={<span>{window.Translation(msg`Città Di Residenza`)}</span>}
                                        type="text"
                                        boxclass="py-1 px-2 w-4/5"
                                        onInput={e => {
                                            this.state.input.residence_city = e.target.value;
                                            this.setState({});
                                        }}
                                        value={this.state.input.residence_city}
                                    />
                                    <InputRow
                                        label={<span>{window.Translation(msg`CAP`)}</span>}
                                        type="text"
                                        boxclass="py-1 px-2 w-1/5"
                                        onInput={e => {
                                            this.state.input.residence_cap = e.target.value;
                                            this.setState({});
                                        }}
                                        value={this.state.input.residence_cap}
                                    />
                                </FiltersRow>
                                <FiltersRow>
                                    <InputRow
                                        label={<span>{window.Translation(msg`Indirizzo Di Residenza`)}</span>}
                                        type="text"
                                        boxclass="py-1 px-2 w-4/5"
                                        onInput={e => {
                                            this.state.input.residence_address = e.target.value;
                                            this.setState({});
                                        }}
                                        value={this.state.input.residence_address}
                                    />
                                    <InputRow
                                        label={<span>{window.Translation(msg`N.`)}</span>}
                                        type="text"
                                        boxclass="py-1 px-2 w-1/5"
                                        onInput={e => {
                                            this.state.input.residence_housenumber = e.target.value;
                                            this.setState({});
                                        }}
                                        value={this.state.input.residence_housenumber}
                                    />
                                </FiltersRow>
                            </FiltersRow>
                        </Fragment>}

                        {/* Form - Step 3 */}
                        {this.state.steps.current === 2 && <Fragment>
                            <FiltersRow>
                                <SelectRow
                                    label={<span>{window.Translation(msg`Paese Di Nascita`)}</span>}
                                    onChange={e => {
                                        this.state.input.birth_country = e.currentTarget.value;
                                        this.setState({});
                                    }}
                                >
                                    <option value=""><Trans>Scegli un paese...</Trans></option>
                                    {this.state.countries.map(
                                        country => <option value={country.code} selected={country.code === this.state.input.birth_country}>{country.name}</option>
                                    )}
                                </SelectRow>
                                <InputRow
                                    label={<span>{window.Translation(msg`Stato/Provincia/Regione Di Nascita`)}</span>}
                                    type="text"
                                    onInput={e => {
                                        this.state.input.birth_state = e.target.value;
                                        this.setState({});
                                    }}
                                    value={this.state.input.birth_state}
                                />
                            </FiltersRow>
                            <FiltersRow>
                                <InputRow
                                    label={<span>{window.Translation(msg`Città Di Nascita`)}</span>}
                                    type="text"
                                    onInput={e => {
                                        this.state.input.birth_city = e.target.value;
                                        this.setState({});
                                    }}
                                    value={this.state.input.birth_city}
                                />
                                <InputRow
                                    label={<span>{window.Translation(msg`Data Di Nascita`)}</span>}
                                    type="date"
                                    onInput={e => {
                                        this.state.input.birth_date = e.target.value;
                                        this.setState({});
                                    }}
                                    value={this.state.input.birth_date}
                                />
                            </FiltersRow>
                        </Fragment>}

                        {/* Form - Step 4 */}
                        {this.state.steps.current === 3 && <FiltersRow>
                            <div class="py-1 px-2 w-1/2">
                                <div>
                                    <div><span><Trans>Il Mio Saldo</Trans></span></div>
                                    <div class="px-2 py-1 rounded border bg-white flex-1 w-full text-link-500">
                                        <MoneyFormatter value={Session.fetch('account').balance} />
                                    </div>
                                </div>
                            </div>
                            <InputRow
                                label={<span>{window.Translation(msg`Saldo Utente`)}<span class="warning-color">*</span></span>}
                                type="number"
                                min="0.00"
                                max={Session.fetch('account').balance}
                                step="1.00"
                                onInput={e => {
                                    this.state.input.amount = e.target.value;
                                    this.setState({});
                                }}
                                value={this.state.input.amount}
                                required={true}
                            />
                        </FiltersRow>}

                        <FiltersRow class="pt-5 gap-2 px-5 flex justify-between w-full">
                            <div>{this.state.steps.current > 0 && <Fragment>
                                <input
                                    type="button"
                                    class="px-4 py-2 bg-blue-whale-600 text-slate-100 rounded"
                                    value={window.Translation(msg`Indietro`)}
                                    onClick={e => this.switchStep(this.state.steps.current - 1)}
                                />
                            </Fragment>}</div>
                            <input
                                id="next-step-button"
                                type="submit"
                                class="px-4 py-2 bg-amber-400 text-black rounded"
                                value={window.Translation(msg`Avanti`)}
                            />
                        </FiltersRow>
                    </form>
                    <p class="italic text-xxs p-5">
                        <Trans>I campi col segno <span class="warning-color">*</span> sono obbligatori</Trans>
                    </p>
                </div>
            </Fragment>}
        </div>;
    }
}

function FormStepLabel({ selected, completed, id, name }) {
    return <a
        href="javascript:void(0);"
        class={"flex gap-1 items-center px-2 " + (selected ? 'text-blue-whale-600' : completed ? 'text-green-600' : 'text-slate-700')}
    >
        <div class={"block leading-tight text-center shrink-0 p-1 rounded-full h-6 w-6 border " + (selected ? 'border-blue-whale-600' : completed ? 'border-green-600' : 'border-slate-700')}>{id}</div>
        <span class={"block "}>{name}</span>
    </a>
}

class UserTransfers extends AwrabetUserTransfers {
    render() {
        return <div class="px-3">

            {this.state.transferstatus !== null && this.state.transferstatus !== true && <p class="p-3 font-bold text-center warning-color">
                <Trans>Errore:</Trans>
                &nbsp;
                {this.state.transferstatus}
            </p>}

            {this.state.transferstatus === true && <p class="p-3 font-bold text-center main-color">
                <Trans>Trasferimento andato a buon fine</Trans>
            </p>}

            <form method="post" onSubmit={e => { e.preventDefault(); this.runTransfer(e.target); }}>
                <FiltersRow>
                    <label class="mx-px px-2">
                        <span class="block text-xs"><Trans>Your Balance</Trans></span>
                        <InputFilter
                            type="number"
                            step="0.01"
                            disabled={true}
                            class="w-40 px-2 py-1 leading-6 rounded border"
                            value={parseFloat(Session.fetch('account').balance).toFixed(2)}
                        />
                    </label>
                </FiltersRow>
                <FiltersRow>
                    {this.state.usernameTransactionMode ? null : <SelectRow
                        id="accounts-selection"
                        label={<span>{window.Translation(msg`Account`)}<span className="warning-color">*</span></span>}
                        onChange={e => {
                            e.target.setCustomValidity('');
                            this.state.input.account = e.currentTarget.value;
                            this.setState({});
                        }}
                    >
                        <option value="" selected={this.state.input.account == ''}><Trans>Scegli un utente...</Trans></option>
                        {!!Session.fetch('users') && Session.fetch('users').map(
                            user => <option value={user.idaccounts} selected={this.state.input.account === user.idaccounts}>{user.username} ({parseFloat(user.saldo).toFixed(2)})</option>
                        )}
                    </SelectRow>}
                    {!this.state.usernameTransactionMode ? null : <InputRow
                        id="accounts-selection"
                        label={<span>{window.Translation(msg`Account`)}<span className="warning-color">*</span></span>}
                        placeholder="+251 (0)"
                        onChange={e => {
                            e.target.setCustomValidity('');
                            this.state.input.account = e.currentTarget.value;
                            this.setState({});
                        }}
                    />}

                    <SelectRow
                        label={<span>{window.Translation(msg`Tipo di Operazione`)}<span className="warning-color">*</span></span>}
                        onChange={e => {
                            this.state.input.transfertype = e.currentTarget.value;
                            this.setState({});
                        }}
                    >
                        <option value="1" selected={this.state.input.transfertype === '1'}><Trans>Deposito</Trans></option>
                        <option value="2" selected={this.state.input.transfertype === '2'}><Trans>Prelievo</Trans></option>
                    </SelectRow>
                </FiltersRow>
                <FiltersRow>
                    <InputRow
                        label={<span>{window.Translation(msg`Motivo`)}</span>}
                        type="text"
                        onInput={e => {
                            this.state.input.reason = e.target.value;
                            this.setState({});
                        }}
                        value={this.state.input.reason}
                    />
                    <InputRow
                        label={<span>{window.Translation(msg`Importo`)}<span className="warning-color">*</span></span>}
                        type="number"
                        min="0.00"
                        step="0.01"
                        onInput={e => {
                            this.state.input.amount = e.target.value;
                            this.setState({});
                        }}
                        value={this.state.input.amount}
                        required={true}
                    />
                </FiltersRow>
                <FiltersRow class="pt-5 px-5 justify-end">
                    <input
                        id="next-step-button"
                        type="submit"
                        class="px-4 py-2 sm:ml-5 bg-amber-400 text-black rounded m-auto"
                        value={window.Translation(msg`Trasferisci Fondi`)}
                    />
                </FiltersRow>
            </form>
            <p class="italic text-xxs p-5">
                <Trans>I campi col segno <span class="warning-color">*</span> sono obbligatori</Trans>
            </p>
        </div>;
    }
}

export class UserList extends AwrabetUserList {
    tableColumns() {
        return [
            <strong class="block text-left body-bg-color"><Trans>ID</Trans></strong>,
            <strong class="block text-center body-bg-color"><Trans>Username</Trans></strong>,
            <strong class="block text-center body-bg-color"><Trans>Email</Trans></strong>,
            <strong class="block text-center body-bg-color"><Trans>Saldo</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Totale Scommesso</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Totale Vinto</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Data Iscrizione</Trans></strong>,
            <strong class="block text-center body-bg-color"><Trans>Movimenti</Trans></strong>
        ];
    }

    tableDataMapper(row) {
        const createdDate = new Date(row.created);
        return [
            <span class="block text-left">{row.idaccounts}</span>,
            <span class="block text-left font-bold">{row.username}</span>,
            <span class="block text-center">{row.email}</span>,
            <span class="block text-right"><MoneyFormatter value={row.saldo} currency={row.currency} /></span>,
            <span class="block text-right"><MoneyFormatter value={row.tot_in} currency={row.currency} /></span>,
            <span class="block text-right"><MoneyFormatter value={row.tot_out} currency={row.currency} /></span>,
            <span class="block text-right">
                {createdDate.toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric' })}
                &nbsp;
                {createdDate.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })}
            </span>,
            <span class="block text-center">
                <a href="javascript:void(0);" onClick={e => !!this.props.openTransactionsClick && this.props.openTransactionsClick(row.username)}>
                    <i class="fa-solid fa-clipboard-list" />
                </a>
            </span>
        ];
    }

    render() {
        return <div class="px-3">
            <FiltersRow class="p-2 text-sm items-end justify-center">
                <label class="mx-px px-2">
                    <span class="block text-xs"><Trans>Username</Trans></span>
                    <InputFilter
                        type="text"
                        class="w-40 px-2 py-1 leading-6 rounded border"
                        value={this.state.searchusername}
                        onInput={e => this.setState({ searchusername: e.target.value })}
                    />
                </label>
                <PerPageFilter
                    perPage={this.state.perPage}
                    pageList={[10, 20, 30, 50, 100]}
                    onInput={
                        ({ perPage }) => {
                            this.state.perPage = perPage;
                            this.setState(this.state);
                        }
                    }
                />
                <a href="javascript:void(0);" class="px-4 py-2 sm:ml-5 bg-amber-400 text-black rounded" onClick={e => this.performSearch()}>
                    <Trans>Avvia Ricerca</Trans> <I.SearchIcon class="h-3 inline-block" />
                </a>
            </FiltersRow>
            <div class="text-xs mt-3">
                <TableFormatter
                    {...this.state.response}
                    style="font-family:'Arial rounded', Arial, sans-serif;"
                    columns={this.tableColumns()}
                    rowClass={'hover:bg-gray-200 border-b'}
                    cellClass={'leading-7'}
                    rowDataMapper={this.tableDataMapper.bind(this)}
                    onNavigation={(newpage, newlowlimit) => this.changePage(newpage)}
                />
            </div>
        </div>;
    }
}

export class UserTransactions extends AwrabetUserTransactions {
    tableColumns() {
        return [
            <strong class="block text-left body-bg-color"><Trans>ID</Trans></strong>,
            <strong class="block text-left body-bg-color"><Trans>Username</Trans></strong>,
            <strong class="block text-center body-bg-color"><Trans>Data</Trans></strong>,
            <strong class="block text-center body-bg-color"><Trans>Descrizione</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Importo</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Saldo</Trans></strong>
        ];
    }

    tableDataMapper(row) {
        const label = !!row['is-sender'] ? 'sender' : 'receiver';
        return [
            <span class="block px-2 text-left">{row.idtransazione}</span>,
            <span class="block px-2 text-left"><strong>{row[label].company}</strong></span>,
            <span class="block px-2 text-center">
                {new Date(row.ts * 1000).toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric' })}
                &nbsp;
                {new Date(row.ts * 1000).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })}
            </span>,
            <span class="block px-2 text-center">{row.description.rawmessage || row.description.message}</span>,
            <span class={'block px-2 text-right ' + (parseFloat(row.amount) < 0 ? 'text-red-600' : 'text-green-600')}>
                {row.wallet_type == "bonus" ? '🎁' : ''}
                <MoneyFormatter value={row.amount} currency={row.currency} />
            </span>,
            <span class="block px-2 text-right"><MoneyFormatter value={row['new_' + label + '_balance']} currency={row.currency} /></span>
        ];
    }

    render() {
        return <div class="px-3">
            <FiltersRow class="p-2 text-sm items-end justify-center">
                <DateHelperFilter
                    {...this.state.dateFilter}
                    onInput={
                        (dateFilter) => {
                            this.state.dateFilter = dateFilter;
                            this.setState(this.state);
                        }
                    }
                />
                <label class="mx-px px-2">
                    <span class="block text-xs"><Trans>Username</Trans></span>
                    <InputFilter
                        type="text"
                        class="w-40 px-2 py-1 leading-6 rounded border"
                        value={this.state.username}
                        onInput={e => this.setState({ username: e.target.value })}
                    />
                </label>
                <PerPageFilter
                    perPage={this.state.perPage}
                    pageList={[10, 20, 30, 50, 100]}
                    onInput={
                        ({ perPage }) => {
                            this.state.perPage = perPage;
                            this.setState(this.state);
                        }
                    }
                />
                <a href="javascript:void(0);" class="px-4 py-2 sm:ml-5 bg-amber-400 text-black rounded" onClick={e => this.performSearch()}>
                    <Trans>Avvia Ricerca</Trans> <I.SearchIcon class="h-3 inline-block" />
                </a>
            </FiltersRow>
            <div class="text-xs mt-3">
                <TableFormatter
                    {...this.state.response}
                    style="font-family:'Arial rounded', Arial, sans-serif;"
                    columns={this.tableColumns()}
                    cellClass={'leading-7'}
                    rowClass={'hover:bg-gray-200 border-b'}
                    rowDataMapper={this.tableDataMapper.bind(this)}
                    onNavigation={(newpage, newlowlimit) => this.changePage(newpage)}
                />
            </div>
        </div>;
    }
}

export let UserTransactionPopup = username => window.open(
    '/admin/transactions/player/' + encodeURIComponent(username),
    'userTransactionsWindow',
    'width=1100,height=600,scrollbars=yes'
);

export class UserTransactionHistoryPopup extends Component {
    render() {
        return <PopupLayout>
            <div class="px-0 py-3 bg-white border text-gray-900">
                <div class="py-2 text-lg text-center"><Trans>Storico Movimenti</Trans></div>
                <UserTransactions username={this.props.username} />
            </div>
        </PopupLayout>;
    }
}